import { memo } from 'react';

export const Workbench = memo(() => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>工作台</title>
    <defs>
      <filter
        x="-40.9%"
        y="-40.4%"
        width="181.8%"
        height="180.8%"
        filterUnits="objectBoundingBox"
        id="filter-1"
      >
        <feGaussianBlur
          stdDeviation="2.72727273"
          in="SourceGraphic"
        ></feGaussianBlur>
      </filter>
      <filter
        x="-37.5%"
        y="-98.8%"
        width="175.0%"
        height="297.6%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feGaussianBlur
          stdDeviation="0.909090909"
          in="SourceGraphic"
        ></feGaussianBlur>
      </filter>
      <radialGradient
        cx="9.69206712%"
        cy="0%"
        fx="9.69206712%"
        fy="0%"
        r="137.645909%"
        gradientTransform="translate(0.096921,0.000000),scale(0.900000,1.000000),rotate(54.889033),translate(-0.096921,-0.000000)"
        id="radialGradient-3"
      >
        <stop stopColor="#7BB0FF" offset="0%"></stop>
        <stop stopColor="#617AFF" offset="100%"></stop>
      </radialGradient>
      <rect
        id="path-4"
        x="0"
        y="0"
        width="20"
        height="18"
        rx="2.72727273"
      ></rect>
      <filter
        x="-128.6%"
        y="-127.0%"
        width="357.1%"
        height="354.1%"
        filterUnits="objectBoundingBox"
        id="filter-6"
      >
        <feGaussianBlur
          stdDeviation="5.45454545"
          in="SourceGraphic"
        ></feGaussianBlur>
      </filter>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="95.8289513%"
        id="linearGradient-7"
      >
        <stop stopColor="#FFFFFF" offset="0%"></stop>
        <stop stopColor="#D2E0FB" offset="100%"></stop>
      </linearGradient>
      <rect
        id="path-8"
        x="3"
        y="5"
        width="14"
        height="11"
        rx="0.909090936"
      ></rect>
      <filter
        x="0.0%"
        y="0.0%"
        width="100.0%"
        height="100.0%"
        filterUnits="objectBoundingBox"
        id="filter-9"
      >
        <feOffset
          dx="0"
          dy="0"
          in="SourceAlpha"
          result="shadowOffsetInner1"
        ></feOffset>
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        ></feComposite>
        <feColorMatrix
          values="0 0 0 0 0.360784314   0 0 0 0 0.380392157   0 0 0 0 1  0 0 0 0.403537137 0"
          type="matrix"
          in="shadowInnerInner1"
        ></feColorMatrix>
      </filter>
      <filter
        x="-146.7%"
        y="-108.7%"
        width="393.3%"
        height="317.4%"
        filterUnits="objectBoundingBox"
        id="filter-10"
      >
        <feOffset
          dx="0"
          dy="2"
          in="SourceAlpha"
          result="shadowOffsetOuter1"
        ></feOffset>
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        ></feGaussianBlur>
        <feColorMatrix
          values="0 0 0 0 0.2994388   0 0 0 0 0.42026868   0 0 0 0 0.997566997  0 0 0 0.294971386 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        ></feColorMatrix>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
          <feMergeNode in="SourceGraphic"></feMergeNode>
        </feMerge>
      </filter>
      <radialGradient
        cx="25.7248816%"
        cy="27.5789403%"
        fx="25.7248816%"
        fy="27.5789403%"
        r="97.5852065%"
        gradientTransform="translate(0.257249,0.275789),scale(1.000000,0.741107),rotate(38.639255),translate(-0.257249,-0.275789)"
        id="radialGradient-11"
      >
        <stop stopColor="#FFFFFF" offset="0%"></stop>
        <stop stopColor="#E0EDFF" offset="100%"></stop>
      </radialGradient>
      <path
        d="M5.79458915,5.62337081 C5.97784623,5.57513111 6.15377304,5.52689141 6.32236957,5.47865171 C6.46897524,5.43730339 6.61924605,5.39595508 6.773182,5.35460676 C6.92711795,5.31325845 7.05539791,5.27535583 7.15802188,5.2408989 L7.00408593,5.78876407 C6.96010423,5.94037455 6.91978767,6.05408242 6.88313625,6.12988766 C6.80983342,6.31595507 6.72370259,6.48823971 6.62474376,6.64674159 C6.52578493,6.80524347 6.43232382,6.94307118 6.34436042,7.06022474 C6.24173645,7.19805245 6.13544734,7.32554309 6.02549309,7.44269664 L4.67305577,7.82516855 L5.78359373,8.01123597 C5.63698806,8.12838952 5.47938696,8.24898877 5.31079044,8.37303371 C5.16418477,8.4764045 4.99742082,8.58494382 4.81049859,8.69865169 C4.62357636,8.81235956 4.42749128,8.91745319 4.22224334,9.01393259 C4.0169954,9.11041199 3.78792404,9.16037454 3.53502925,9.16382023 C3.28213447,9.16726593 3.04206768,9.15176031 2.81482889,9.11730338 C2.55093868,9.08284645 2.28704848,9.02426968 2.02315827,8.94157305 C2.10379138,8.82441949 2.19175478,8.69348316 2.28704848,8.54876406 C2.36768159,8.42471911 2.46480785,8.27827716 2.57842725,8.10943821 C2.69204665,7.94059926 2.81116376,7.75280899 2.93577858,7.54606742 C3.28763219,6.98786518 3.62849037,6.44000001 3.95835313,5.90247192 C4.28821589,5.36494383 4.58509237,4.87910113 4.84898258,4.44494383 C5.1495242,3.94187267 5.4390704,3.46636705 5.71762118,3.01842697 C5.37309785,3.3905618 5.01024882,3.80749064 4.62907407,4.26921349 C4.29921131,4.66202247 3.93269714,5.12891386 3.52953154,5.66988764 C3.12636593,6.21086143 2.71587005,6.80179776 2.29804389,7.44269663 C2.21008049,7.57363296 2.11112167,7.72524345 2.00116742,7.89752809 C1.89121317,8.06981274 1.7757612,8.25243446 1.65481152,8.44539326 C1.53386184,8.63835205 1.40924702,8.83647939 1.28096706,9.03977528 C1.1526871,9.24307117 1.0262397,9.44119851 0.90162488,9.6341573 C0.608413537,10.0820974 0.30787191,10.5507116 0,11.04 C0.00733027975,10.8952809 0.036651414,10.7092135 0.0879634029,10.4817978 C0.131945104,10.2888389 0.20524794,10.0476404 0.30787191,9.75820224 C0.41049588,9.46876404 0.557101552,9.12764045 0.747688925,8.73483146 C0.872303742,8.48674157 0.967597428,8.29378277 1.03356998,8.15595506 C1.09954254,8.01812734 1.15085452,7.91131086 1.18750594,7.83550562 C1.22415735,7.75280899 1.25347849,7.69767791 1.27546934,7.67011236 C1.23881793,7.62876405 1.23148764,7.54606742 1.25347849,7.42202248 C1.26813906,7.3117603 1.31028819,7.15153558 1.37992588,6.94134831 C1.44956357,6.73116105 1.56868068,6.43655431 1.73727721,6.05752809 C1.90587373,5.67161049 2.1276148,5.25640449 2.40250044,4.81191011 C2.67738608,4.36741572 2.98709057,3.92636703 3.33161389,3.48876404 C3.67613721,3.05116104 4.04998168,2.62734082 4.45314728,2.21730337 C4.85631288,1.80726591 5.26864133,1.44374532 5.69013263,1.12674157 C6.11162394,0.809737824 6.53311524,0.549588012 6.95460654,0.346292133 C7.37609785,0.142996254 7.78476116,0.0275655431 8.18059647,0 C8.18792675,0.241198499 8.16227076,0.559925092 8.1036285,0.95617978 C8.04498624,1.35243447 7.9716834,1.77625469 7.88371999,2.22764045 C7.79575658,2.67902621 7.69679775,3.13730336 7.58684351,3.60247191 C7.47688927,4.06764045 7.37060016,4.48973783 7.26797618,4.86876405 L5.79458915,5.62337081 Z"
        id="path-12"
      ></path>
    </defs>
    <g id="UI稿" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="首页-交互细节" transform="translate(-839.000000, -239.000000)">
        <g id="nav/选中状态备份" transform="translate(827.000000, 229.000000)">
          <g id="nav/工作台-s" transform="translate(12.000000, 10.000000)">
            <ellipse
              id="椭圆形"
              fill="#5363FF"
              opacity="0.158657982"
              filter="url(#filter-1)"
              cx="10"
              cy="12.88"
              rx="10"
              ry="10.12"
            ></ellipse>
            <ellipse
              id="椭圆形"
              fill="#FFFFFF"
              opacity="0.437244234"
              filter="url(#filter-2)"
              cx="10"
              cy="18.02"
              rx="3.63636364"
              ry="1.38"
            ></ellipse>
            <g id="椭圆形" transform="translate(0.000000, 1.000000)">
              <mask id="mask-5" fill="white">
                <use xlinkHref="#path-4"></use>
              </mask>
              <use
                id="形状结合"
                fill="url(#radialGradient-3)"
                xlinkHref="#path-4"
              ></use>
              <ellipse
                fill="#C44DFF"
                opacity="0.330830892"
                filter="url(#filter-6)"
                mask="url(#mask-5)"
                cx="1.81818182"
                cy="1.84"
                rx="6.36363636"
                ry="6.44"
              ></ellipse>
            </g>
            <g id="矩形备份-8" opacity="0.221579415">
              <use
                fill="url(#linearGradient-7)"
                fillRule="evenodd"
                xlinkHref="#path-8"
              ></use>
              <use
                fill="black"
                fillOpacity="1"
                filter="url(#filter-9)"
                xlinkHref="#path-8"
              ></use>
            </g>
            <g
              id="路径-15"
              filter="url(#filter-10)"
              transform="translate(7.000000, 2.840000)"
            >
              <mask id="mask-13" fill="white">
                <use xlinkHref="#path-12"></use>
              </mask>
              <use
                id="蒙版"
                fill="url(#radialGradient-11)"
                fillRule="nonzero"
                xlinkHref="#path-12"
              ></use>
              <path
                d="M-0.123986393,10.95401 C1.84095012,7.87904956 3.00755943,6.10472872 3.37584155,5.63104754 C3.92826472,4.92052578 5.62499095,2.90833251 5.76570393,2.90833251 C5.6908667,3.12836137 3.76896539,5.93897287 4.16333634e-17,11.340167 L-0.123986393,10.95401 Z"
                fill="#D1D9F9"
                mask="url(#mask-13)"
              ></path>
              <path
                d="M2.06355857,8.76938223 C1.96645637,8.80008723 1.88466411,8.88549041 1.81818182,9.02559176 C2.72307102,9.38596936 3.38125667,9.50871117 3.79273876,9.39381721 C4.40996189,9.22147627 7.27952362,7.79024828 7.40937253,5.64905964 C7.53922144,3.50787099 8.64076641,0.421869233 8.18181818,-2.20623519e-14 C7.87025195,1.49426646 7.00514096,4.76447851 7.00514096,4.76447851 C7.00514096,4.76447851 6.59199528,5.05933889 5.76570393,5.64905964 L6.87035979,5.52 C6.63189929,6.19740938 6.29712453,6.76204097 5.86603551,7.21389477 C5.3220293,7.48234157 4.92436938,7.68609949 4.67305577,7.82516855 L5.20887616,7.95340942 C4.67701026,8.57711127 3.62857107,8.84910221 2.06355857,8.76938223 Z"
                id="路径-16"
                fill="#D1D9F9"
                mask="url(#mask-13)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
));
